// extracted by mini-css-extract-plugin
export var chevronIcon = "_b2-2";
export var teamName = "_b2-1";
export var teamSwitcherButton = "_b2-0";